import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/dashboard/_base/logs/$id")({
  component: Outlet,
  params: {
    parse: (value) => ({ id: Number(value.id) })
  }
});
